import FindStoreContainer from './FindStoreContainer';
export default FindStoreContainer;
